import type { DateRange } from "@src/appV2/lib";
import { addDays, endOfDay, startOfDay } from "date-fns";

import { DEFAULT_SHIFT_DISCOVERY_DATE_RANGE_WINDOW_IN_DAYS } from "./useShiftDiscoveryDaysToFetch";

// How many days from now to load open shifts for by default
export function getShiftDiscoveryDefaultDateRange(
  offsetInDays: number = DEFAULT_SHIFT_DISCOVERY_DATE_RANGE_WINDOW_IN_DAYS
): DateRange {
  return {
    startDate: startOfDay(new Date()),
    endDate: endOfDay(addDays(new Date(), offsetInDays)),
  };
}
